"use strict";
// Copyright (C) 2017-2025 Smart code 203358507
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RouteFocusedProvider = exports.useRouteActive = void 0;
var react_1 = __importDefault(require("react"));
var RouteFocusedContext = react_1.default.createContext(true);
var useRouteActive = function () {
    return react_1.default.useContext(RouteFocusedContext);
};
exports.useRouteActive = useRouteActive;
var useRouteFocused = function () {
    var routeActive = (0, exports.useRouteActive)();
    var _a = react_1.default.useState(document.hasFocus()), isFocused = _a[0], setIsFocused = _a[1];
    react_1.default.useEffect(function () {
        var handleFocus = function () { return setIsFocused(true); };
        var handleBlur = function () { return setIsFocused(false); };
        window.addEventListener('focus', handleFocus);
        window.addEventListener('blur', handleBlur);
        // catch focus changes that happened before the listeners were attached
        setIsFocused(document.hasFocus());
        return function () {
            window.removeEventListener('focus', handleFocus);
            window.removeEventListener('blur', handleBlur);
        };
    }, []);
    return routeActive && isFocused;
};
exports.RouteFocusedProvider = RouteFocusedContext.Provider;
exports.default = useRouteFocused;
